import { render, staticRenderFns } from "./ProfessionalRolesDialog.vue?vue&type=template&id=7a066e6e&scoped=true&"
import script from "./ProfessionalRolesDialog.vue?vue&type=script&lang=js&"
export * from "./ProfessionalRolesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalRolesDialog.vue?vue&type=style&index=0&id=7a066e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a066e6e",
  null
  
)

export default component.exports